const {indexList} = require("./variables");
/**
 *
 * @param type {"ISPU" | "AQI" | "EAQI" | "DIBA" | "ICQA" | "APIMS" | "AQHI" | "AQHI-HK" | "ICA" | "AHKI-QB" | "AQI-CH" | "IQAR" | "AQHI-MX"}
 * @param local
 * @return {string[]}
 */
const getAQILegend = (type, local = "en") => {
    const legends = {
        EAQI: {
            en: ["Good", "Fair", "Moderate", "Poor", "Very Poor", "Extremely Poor"],
            es: ["Buena", "Aceptable", "Moderada", "Pobre", "Muy pobre", "Extremadamente pobre"],
            ca: ["Bo", "Acceptable", "Moderat", "Dolent", "Molt dolent", "Extremadament dolent"],
            fr: ["Bon", "Acceptable", "Modéré", "Mauvais", "Très mauvais", "Extrêmement mauvais"],
            it: ["Buono", "Accettabile", "Moderato", "Povero", "Molto povero", "Estremamente povero"],
            zh: ["良好", "可接受", "中等", "差", "很差", "极差"],
            hr: ["Dobro", "Prihvatljivo", "Umjereno", "Loše", "Vrlo loše", "Izuzetno loše"],
            id: ["Baik", "Dapat Diterima", "Sedang", "Buruk", "Sangat Buruk", "Sangat Buruk Sekali"],
            ms: ["Baik", "Boleh Diterima", "Sederhana", "Buruk", "Sangat Buruk", "Sangat Buruk Sekali"],
            nl: ["Goed", "Acceptabel", "Matig", "Slecht", "Zeer slecht", "Extreem slecht"],
            pt: ["Bom", "Aceitável", "Moderado", "Pobre", "Muito pobre", "Extremamente pobre"],
            tr: ["İyi", "Kabul edilebilir", "Orta", "Kötü", "Çok kötü", "Aşırı kötü"],
            el: ["Καλή", "Αποδεκτή", "Μέτρια", "Φτωχή", "Πολύ φτωχή", "Εξαιρετικά φτωχή"],
            ja: ["良好", "許容範囲内", "適度", "悪い", "非常に悪い", "極めて悪い"],
            de: ["Gut", "Akzeptabel", "Mäßig", "Schlecht", "Sehr schlecht", "Extrem schlecht"]
        },
        AQI: {
            en: ["Good", "Moderate", "Unhealthy for sensitive groups", "Unhealthy", "Very Unhealthy", "Hazardous"],
            es: ["Bueno", "Moderado", "No saludable para personas sensibles", "No saludable", "Muy insalubre", "Peligroso"],
            ca: ["Bé", "Moderat", "Insalubre per a grups sensibles", "Insalubre", "Molt insalubre", "Perillós"],
            fr: ["Bon", "Modéré", "Malsain pour les groupes sensibles", "Malsain", "Très malsain", "Dangereux"],
            it: ["Buono", "Moderato", "Non salutare per gruppi sensibili", "Non salutare", "Molto insalubre", "Pericoloso"],
            zh: ["良好", "中等", "对敏感人群不健康", "不健康", "非常不健康", "有害"],
            hr: ["Dobro", "Umjereno", "Nezdravo za osjetljive grupe", "Nezdravo", "Vrlo nezdravo", "Opasno"],
            id: ["Baik", "Sedang", "Tidak sehat bagi kelompok sensitif", "Tidak sehat", "Sangat tidak sehat", "Berbahaya"],
            ms: ["Baik", "Sederhana", "Tidak sihat untuk kumpulan sensitif", "Tidak sihat", "Sangat tidak sihat", "Berbahaya"],
            nl: ["Goed", "Matig", "Ongezond voor gevoelige groepen", "Ongezond", "Zeer ongezond", "Gevaarlijk"],
            pt: ["Bom", "Moderado", "Insalubre para grupos sensíveis", "Insalubre", "Muito insalubre", "Perigoso"],
            tr: ["İyi", "Orta", "Hassas gruplar için sağlıksız", "Sağlıksız", "Çok sağlıksız", "Tehlikeli"],
            el: ["Καλή", "Μέτρια", "Ανθυγιεινή για ευαίσθητες ομάδες", "Ανθυγιεινή", "Πολύ ανθυγιεινή", "Επικίνδυνη"],
            ja: ["良好", "適度", "敏感なグループにとって健康でない", "健康でない", "非常に健康でない", "危険"],
            de: ["Gut", "Mäßig", "Ungesund für empfindliche Gruppen", "Ungesund", "Sehr ungesund", "Gefährlich"]
        },
        ISPU: {
            en: ["Good", "Medium", "Unhealthy", "Very Unhealthy", "Dangerous"],
            es: ["Buena", "Medio", "No saludable", "Muy insalubre", "Peligrosa"],
            ca: ["Bo", "Mitjà", "No saludable", "Molt insalubre", "Perillosa"],
            fr: ["Bon", "Moyen", "Malsain", "Très malsain", "Dangereux"],
            it: ["Buono", "Medio", "Non salutare", "Molto insalubre", "Pericoloso"],
            zh: ["良好", "中等", "不健康", "非常不健康", "有害"],
            hr: ["Dobro", "Srednje", "Nezdravo", "Vrlo nezdravo", "Opasno"],
            id: ["Baik", "Sedang", "Tidak sehat", "Sangat tidak sehat", "Berbahaya"],
            ms: ["Baik", "Sederhana", "Tidak sihat", "Sangat tidak sihat", "Berbahaya"],
            nl: ["Goed", "Gemiddeld", "Ongezond", "Zeer ongezond", "Gevaarlijk"],
            pt: ["Bom", "Médio", "Insalubre", "Muito insalubre", "Perigoso"],
            tr: ["İyi", "Orta", "Sağlıksız", "Çok sağlıksız", "Tehlikeli"],
            el: ["Καλή", "Μέτρια", "Ανθυγιεινή", "Πολύ ανθυγιεινή", "Επικίνδυνη"],
            ja: ["良好", "中程度", "健康でない", "非常に健康でない", "危険"],
            de: ["Gut", "Mittel", "Ungesund", "Sehr ungesund", "Gefährlich"]
        },
        DIBA: {
            en: ["Very Low", "Low", "Moderate", "High"],
            es: ["Muy bajo", "Bajo", "Moderado", "Elevado"],
            ca: ["Molt baix", "Baix", "Moderat", "Alt"],
            fr: ["Très bas", "Bas", "Modéré", "Haut"],
            it: ["Molto basso", "Basso", "Moderato", "Alto"],
            zh: ["非常低", "低", "中等", "高"],
            hr: ["Vrlo nisko", "Nisko", "Umjereno", "Visoko"],
            id: ["Sangat Rendah", "Rendah", "Sedang", "Tinggi"],
            ms: ["Sangat Rendah", "Rendah", "Sederhana", "Tinggi"],
            nl: ["Zeer laag", "Laag", "Matig", "Hoog"],
            pt: ["Muito baixo", "Baixo", "Moderado", "Alto"],
            tr: ["Çok düşük", "Düşük", "Orta", "Yüksek"],
            el: ["Πολύ χαμηλό", "Χαμηλό", "Μέτριο", "Υψηλό"],
            ja: ["非常に低い", "低い", "適度", "高い"],
            de: ["Sehr niedrig", "Niedrig", "Mäßig", "Hoch"]
        },
        ICQA: {
            en: ["Good", "Reasonably good", "Fair", "Unfavorable", "Very unfavorable", "Extremely unfavorable"],
            es: ["Buena", "Razonablemente buena", "Regular", "Desfavorable", "Muy desfavorable", "Extremadamente desfavorable"],
            ca: ["Bona", "Raonablement bona", "Regular", "Desfavorable", "Molt desfavorable", "Extremadament desfavorable"],
            fr: ["Bon", "Assez bon", "Juste", "Défavorable", "Très défavorable", "Extrêmement défavorable"],
            it: ["Buono", "Abbastanza buono", "Equo", "Sfavorevole", "Molto sfavorevole", "Estremamente sfavorevole"],
            zh: ["良好", "相当好", "公平", "不利", "非常不利", "极其不利"],
            hr: ["Dobro", "Prilično dobro", "Pravedno", "Nepovoljno", "Vrlo nepovoljno", "Izuzetno nepovoljno"],
            id: ["Baik", "Cukup baik", "Adil", "Tidak menguntungkan", "Sangat tidak menguntungkan", "Sangat tidak menguntungkan"],
            ms: ["Baik", "Cukup baik", "Adil", "Tidak menguntungkan", "Sangat tidak menguntungkan", "Sangat tidak menguntungkan"],
            nl: ["Goed", "Redelijk goed", "Eerlijk", "Ongunstig", "Zeer ongunstig", "Extreem ongunstig"],
            pt: ["Bom", "Razoavelmente bom", "Justo", "Desfavorável", "Muito desfavorável", "Extremamente desfavorável"],
            tr: ["İyi", "Oldukça iyi", "Adil", "Olumsuz", "Çok olumsuz", "Aşırı olumsuz"],
            el: ["Καλή", "Αρκετά καλή", "Δίκαιη", "Μη ευνοϊκή", "Πολύ μη ευνοϊκή", "Ακραία μη ευνοϊκή"],
            ja: ["良好", "かなり良好", "公正", "不利", "非常に不利", "極めて不利"],
            de: ["Gut", "Ziemlich gut", "Fair", "Ungünstig", "Sehr ungünstig", "Extrem ungünstig"]
        },
        APIMS: {
            en: ["Good", "Moderate", "Unhealthy", "Very Unhealthy", "Hazardous"],
            es: ["Buena", "Moderada", "No saludable", "Muy insalubre", "Peligrosa"],
            ca: ["Bona", "Moderada", "No saludable", "Molt insalubre", "Perillosa"],
            fr: ["Bon", "Modérée", "Malsaine", "Très malsaine", "Dangereuse"],
            it: ["Buona", "Moderata", "Non salutare", "Molto insalubre", "Pericolosa"],
            zh: ["良好", "中等", "不健康", "非常不健康", "有害"],
            hr: ["Dobro", "Umjereno", "Nezdravo", "Vrlo nezdravo", "Opasno"],
            id: ["Baik", "Sedang", "Tidak sehat", "Sangat tidak sehat", "Berbahaya"],
            ms: ["Baik", "Sederhana", "Tidak sihat", "Sangat tidak sihat", "Berbahaya"],
            nl: ["Goed", "Matig", "Ongezond", "Zeer ongezond", "Gevaarlijk"],
            pt: ["Bom", "Moderado", "Insalubre", "Muito insalubre", "Perigoso"],
            tr: ["İyi", "Orta", "Sağlıksız", "Çok sağlıksız", "Tehlikeli"],
            el: ["Καλή", "Μέτρια", "Ανθυγιεινή", "Πολύ ανθυγιεινή", "Επικίνδυνη"],
            ja: ["良好", "適度", "健康でない", "非常に健康でない", "危険"],
            de: ["Gut", "Mäßig", "Ungesund", "Sehr ungesund", "Gefährlich"]
        },
        AQHI: {
            en: ["Low", "Moderate", "High", "Very high"],
            es: ["Bajo", "Moderado", "Alto", "Muy alto"],
            ca: ["Baix", "Moderat", "Alt", "Molt alt"],
            fr: ["Faible", "Modéré", "Élevé", "Très élevé"],
            it: ["Basso", "Moderato", "Alto", "Molto alto"],
            zh: ["低", "中等", "高", "很高"],
            hr: ["Nisko", "Umjereno", "Visoko", "Vrlo visoko"],
            id: ["Rendah", "Sedang", "Tinggi", "Sangat tinggi"],
            ms: ["Rendah", "Sederhana", "Tinggi", "Sangat tinggi"],
            nl: ["Laag", "Matig", "Hoog", "Zeer hoog"],
            pt: ["Baixo", "Moderado", "Alto", "Muito alto"],
            tr: ["Düşük", "Orta", "Yüksek", "Çok yüksek"],
            el: ["Χαμηλό", "Μέτριο", "Υψηλό", "Πολύ υψηλό"],
            ja: ["低い", "適度", "高い", "非常に高い"],
            de: ["Niedrig", "Mäßig", "Hoch", "Sehr hoch"]
        },
        "AQHI-HK": {
            en: ["Low", "Moderate", "High", "Very high", "Serious"],
            es: ["Bajo", "Moderado", "Alto", "Muy alto", "Serio"],
            ca: ["Baix", "Moderat", "Alt", "Molt alt", "Serios"],
            fr: ["Faible", "Modéré", "Élevé", "Très élevé", "Grave"],
            it: ["Basso", "Moderato", "Alto", "Molto alto", "Serio"],
            zh: ["低", "中等", "高", "很高", "嚴重"],
            hr: ["Nisko", "Umjereno", "Visoko", "Vrlo visoko", "Ozbiljno"],
            id: ["Rendah", "Sedang", "Tinggi", "Sangat tinggi", "Serius"],
            ms: ["Rendah", "Sederhana", "Tinggi", "Sangat tinggi", "Serius"],
            nl: ["Laag", "Matig", "Hoog", "Zeer hoog", "Ernstig"],
            pt: ["Baixo", "Moderado", "Alto", "Muito alto", "Sério"],
            tr: ["Düşük", "Orta", "Yüksek", "Çok yüksek", "Ciddi"],
            el: ["Χαμηλό", "Μέτριο", "Υψηλό", "Πολύ υψηλό", "Σοβαρό"],
            ja: ["低い", "適度", "高い", "非常に高い", "深刻"],
            de: ["Niedrig", "Mäßig", "Hoch", "Sehr hoch", "Ernst"]
        },
        ICA: {
            es: ["Buena", "Aceptable", "Dañina a la salud de grupos sensibles", "Dañina a la salud", "Muy dañina a la salud", "Peligrosa"],
            en: ["Good", "Acceptable", "Harmful to sensitive groups", "Harmful", "Very harmful", "Dangerous"],
            ca: ["Bo", "Acceptable", "Danyosa per a la salut de grups sensibles", "Danyosa per a la salut", "Molt danyosa per a la salut", "Perillosa"],
            fr: ["Bon", "Acceptable", "Nocif pour les groupes sensibles", "Nocif", "Très nocif", "Dangereux"],
            it: ["Buono", "Accettabile", "Dannoso per la salute di gruppi sensibili", "Dannoso per la salute", "Molto dannoso per la salute", "Pericoloso"],
            zh: ["良好", "可接受", "对敏感人群有害", "有害", "非常有害", "危险"],
            hr: ["Dobro", "Prihvatljivo", "Štetno za osjetljive grupe", "Štetno", "Vrlo štetno", "Opasno"],
            id: ["Baik", "Dapat Diterima", "Berbahaya bagi kelompok sensitif", "Berbahaya", "Sangat berbahaya", "Berbahaya"],
            ms: ["Baik", "Boleh Diterima", "Berbahaya bagi kumpulan sensitif", "Berbahaya", "Sangat berbahaya", "Berbahaya"],
            nl: ["Goed", "Acceptabel", "Schadelijk voor gevoelige groepen", "Schadelijk", "Zeer schadelijk", "Gevaarlijk"],
            pt: ["Bom", "Aceitável", "Prejudicial para grupos sensíveis", "Prejudicial", "Muito prejudicial", "Perigoso"],
            tr: ["İyi", "Kabul edilebilir", "Hassas gruplar için zararlı", "Zararlı", "Çok zararlı", "Tehlikeli"],
            el: ["Καλή", "Αποδεκτή", "Βλαβερή για ευαίσθητες ομάδες", "Βλαβερή", "Πολύ βλαβερή", "Επικίνδυνη"],
            ja: ["良好", "許容範囲内", "健康に有害", "有害", "非常に有害", "危険"],
            de: ["Gut", "Akzeptabel", "Schädlich für empfindliche Gruppen", "Schädlich", "Sehr schädlich", "Gefährlich"]
        },
        "AQI-QB": {
            en: ["Good", "Acceptable", "Poor"],
            es: ["Buena", "Aceptable", "Pobre"],
            ca: ["Bo", "Acceptable", "Pobre"],
            fr: ["Bon", "Acceptable", "Mauvais"],
            it: ["Buono", "Accettabile", "Scarso"],
            zh: ["良好", "可接受", "差"],
            hr: ["Dobro", "Prihvatljivo", "Loše"],
            id: ["Baik", "Dapat Diterima", "Buruk"],
            ms: ["Baik", "Boleh Diterima", "Buruk"],
            nl: ["Goed", "Acceptabel", "Slecht"],
            pt: ["Bom", "Aceitável", "Pobre"],
            tr: ["İyi", "Kabul edilebilir", "Kötü"],
            el: ["Καλή", "Αποδεκτή", "Φτωχή"],
            ja: ["良好", "許容範囲内", "悪い"],
            de: ["Gut", "Akzeptabel", "Schlecht"]
        },
        "AQI-CH": {
            es: ["Bueno", "Regular", "Alerta", "Pre-emergencia", "Emergencia"],
            en: ["Good", "Fair", "Alert", "Pre-emergency", "Emergency"],
            ca: ["Bo", "Regular", "Alerta", "Pre-emergència", "Emergència"],
            fr: ["Bon", "Moyen", "Alerte", "Pré-urgence", "Urgence"],
            it: ["Buono", "Moderato", "Allarme", "Pre-emergenza", "Emergenza"],
            zh: ["良好", "中等", "警报", "预警", "紧急"],
            hr: ["Dobro", "Umjereno", "Upozorenje", "Pre-izvanredno", "Izvanredno"],
            id: ["Baik", "Sedang", "Peringatan", "Prapenangan", "Darurat"],
            ms: ["Baik", "Sederhana", "Amaran", "Prapemergensi", "Kecemasan"],
            nl: ["Goed", "Matig", "Waarschuwing", "Pre-noodsituatie", "Noodsituatie"],
            pt: ["Bom", "Moderado", "Alerta", "Pré-emergência", "Emergência"],
            tr: ["İyi", "Orta", "Uyarı", "Ön acil durum", "Acil durum"],
            el: ["Καλή", "Μέτρια", "Προειδοποίηση", "Προ-έκτακτη ανάγκη", "Έκτακτη ανάγκη"],
            ja: ["良好", "許容範囲内", "警報", "事前緊急", "緊急"],
            de: ["Gut", "Akzeptabel", "Alarm", "Vor-Notfall", "Notfall"]
        },
        DAQI: {
            en: ["Low", "Moderate", "High", "Very High"],
            es: ["Bajo", "Moderado", "Alto", "Muy Alto"],
            ca: ["Baix", "Moderat", "Alt", "Molt Alt"],
            fr: ["Faible", "Modéré", "Élevé", "Très élevé"],
            it: ["Basso", "Moderato", "Alto", "Molto Alto"],
            zh: ["低", "中等", "高", "很高"],
            hr: ["Nisko", "Umjereno", "Visoko", "Vrlo Visoko"],
            id: ["Rendah", "Sedang", "Tinggi", "Sangat Tinggi"],
            ms: ["Rendah", "Sederhana", "Tinggi", "Sangat Tinggi"],
            nl: ["Laag", "Matig", "Hoog", "Zeer Hoog"],
            pt: ["Baixo", "Moderado", "Alto", "Muito Alto"],
            tr: ["Düşük", "Orta", "Yüksek", "Çok Yüksek"],
            el: ["Χαμηλό", "Μέτριο", "Υψηλό", "Πολύ Υψηλό"],
            ja: ["低い", "適度", "高い", "非常に高い"],
            de: ["Niedrig", "Mäßig", "Hoch", "Sehr Hoch"]
        },
        IQAR: {
            pt: ["Boa", "Moderada", "Ruim", "Muito Ruim", "Péssima"],
            en: ["Good", "Moderate", "Poor", "Very Poor", "Extremely Poor"],
            es: ["Buena", "Moderada", "Mala", "Muy Mala", "Extremadamente Mala"],
            ca: ["Bo", "Moderada", "Dolenta", "Molt Dolenta", "Extremadament Dolenta"],
            fr: ["Bon", "Modérée", "Mauvaise", "Très Mauvaise", "Extrêmement Mauvaise"],
            it: ["Buona", "Moderata", "Scadente", "Molto Scadente", "Estremamente Scadente"],
            zh: ["良好", "中等", "差", "很差", "极差"],
            hr: ["Dobro", "Umjereno", "Loše", "Vrlo Loše", "Izuzetno Loše"],
            id: ["Baik", "Sedang", "Buruk", "Sangat Buruk", "Sangat Buruk Sekali"],
            ja: ["良好", "適度", "悪い", "非常に悪い", "極めて悪い"],
            de: ["Gut", "Mäßig", "Schlecht", "Sehr Schlecht", "Extrem Schlecht"],
            el: ["Καλή", "Μέτρια", "Κακή", "Πολύ Κακή", "Εξαιρετικά Κακή"],
            tr: ["İyi", "Orta", "Kötü", "Çok Kötü", "Aşırı Kötü"],
            nl: ["Goed", "Matig", "Slecht", "Zeer Slecht", "Extreem Slecht"],
            ms: ["Baik", "Sederhana", "Buruk", "Sangat Buruk", "Sangat Buruk Sekali"]
        },
        "AQHI-MX": {
            es: ["Buena", "Aceptable", "Mala", "Muy mala", "Extremadamente mala"],
            en: ["Good", "Acceptable", "Poor", "Very Poor", "Extremely Poor"],
            ca: ["Bo", "Acceptable", "Dolenta", "Molt Dolenta", "Extremadament Dolenta"],
            fr: ["Bon", "Acceptable", "Mauvaise", "Très Mauvaise", "Extrêmement Mauvaise"],
            it: ["Buona", "Accettabile", "Scadente", "Molto Scadente", "Estremamente Scadente"],
            zh: ["良好", "可接受", "差", "很差", "极差"],
            hr: ["Dobro", "Prihvatljivo", "Loše", "Vrlo Loše", "Izuzetno Loše"],
            id: ["Baik", "Dapat Diterima", "Buruk", "Sangat Buruk", "Sangat Buruk Sekali"],
            ja: ["良好", "許容範囲内", "悪い", "非常に悪い", "極めて悪い"],
            de: ["Gut", "Akzeptabel", "Schlecht", "Sehr Schlecht", "Extrem Schlecht"],
            el: ["Καλή", "Αποδεκτή", "Κακή", "Πολύ Κακή", "Εξαιρετικά Κακή"],
            tr: ["İyi", "Kabul edilebilir", "Kötü", "Çok Kötü", "Aşırı Kötü"],
            nl: ["Goed", "Acceptabel", "Slecht", "Zeer Slecht", "Extreem Slecht"],
            ms: ["Baik", "Boleh Diterima", "Buruk", "Sangat Buruk", "Sangat Buruk Sekali"]
        }
    };
    const includeLocale = Object.keys(legends[type]).includes(local);

    const locale = includeLocale ? local : "en";

    return legends[type][locale];
};

const indexColors = {
    AQI: ["#B7DCB3", "#FBF89B", "#FBB988", "#F49EA2",
        "#C99BC8", "#A67288"],
    EAQI: ["#63e0d5", "#6dc3ac", "#e6dd78", "#ee7777",
        "#8e5168", "#7a447d"],
    ISPU: ["#8dcb8d", "#508fbf", "#f7ce54", "#f26161",
        "#747474"],
    ICQA: ["#62abd1", "#539d77", "#dfd675", "#c26069",
        "#76383f", "#a171a2"],
    DIBA: ["#6abde3", "#96c66a", "#f1f162", "#ee5355"],
    APIMS: ["#6b9fea", "#96d28d", "#f2f173", "#f9b54d",
        "#ff6c5e"],
    AQHI: ["#6b9fea", "#f9b54d", "#ff6c5e", "#76383f"],
    "AQHI-HK": ["#99f48d", "#f5ca68",
        "#f78089", "#b17c66", "#342c2c"],
    ICA: ["#96c66a", "#f1f162", "#ee7a53", "#e62c2e",
        "#a171a2", "#694434"],
    "AQI-QB": ["#96c66a", "#f1f162", "#ee5355"],
    "AQI-CH": ["#96c66a", "#f1f162", "#ee7a53", "#e62c2e",
        "#a171a2"],
    DAQI: ["#96c66a", "#ee7a53", "#e62c2e", "#a171a2"],
    IQAR: ["#96c66a", "#f1f162", "#ee7a53",
        "#e62c2e", "#a171a2"],
    "AQHI-MX": ["#96c66a", "#f1f162", "#ee7a53",
        "#e62c2e", "#a171a2"]
};

const airQualityIndexColors = {
    AQI: ["#52B946", "#F3EC18", "#F67D1E", "#ED1C25",
        "#7D287C", "#480D27"],
    EAQI: ["#73e7df", "#4fc5a5", "#e7de00", "#f55050",
        "#920434", "#7b227e"],
    ISPU: ["#31c535", "#026ebb", "#f5b900", "#f70000",
        "#030303"],
    ICQA: ["#399dc7", "#319c5c", "#e9dc4a", "#c23442",
        "#6b181f", "#9f5aa0"],
    DIBA: ["#05aae7", "#8dc950", "#f5f513", "#f50309"],
    AQHI: ["#3dc4ee", "#f9c931", "#e8202b", "#600f11"],
    APIMS: ["#0000FF", "#428500", "#FFF833", "#FD8800",
        "#D41413"],
    "AQHI-HK": ["#45AF35", "#F6AB00",
        "#E50010", "#AA4514","#231716"],
    "AQI-QB": ["#00E400", "#FFFF00", "#FF0000"],
    ICA: ["#52B946", "#F3EC18", "#F67D1E", "#ED1C25",
        "#7D287C", "#694434"],
    "AQI-CH": ["#52B946", "#F3EC18", "#F67D1E",
        "#ED1C25","#7D287C"],
    DAQI: ["#00E400", "#F67D1E", "#FF0000", "#7D287C"],
    IQAR: ["#00E400", "#FFD800", "#FF7E00", "#FF0000",
        "#7D287C"],
    "AQHI-MX": ["#00E400", "#FFD800", "#FF7E00", "#FF0000",
        "#7D287C"]
};

const CATEGORICAL_INDEXES = [indexList.EAQI, indexList.ICQA, indexList.DIBA, indexList["AQI-CH"], indexList["AQHI-MX"]];

const getIndexRange = (indexType) => {
    if (CATEGORICAL_INDEXES.includes(indexType)) return null;

    const range = {};
    range[indexList.AQI] = [50, 100, 150, 200, 300, 500];
    range[indexList.ISPU] = [50, 100, 200, 300, Infinity];
    range[indexList.AQHI] = [3, 6, 10, Infinity];
    range[indexList.APIMS] = [50, 100, 200, 300, Infinity];
    range[indexList["AQHI-HK"]] = [3, 6, 7, 10, Infinity];
    range[indexList["AQI-QB"]] = [25, 50, Infinity];
    range[indexList.ICA] = [50, 100, 150, 200, 300, 500];
    range[indexList.DAQI] = [3, 6, 10, Infinity];
    range[indexList.IQAR] = [40, 80, 120, 200, Infinity];

    return range[indexType];
};

const getValueColorPosition = (value, rangeValues) => {
    if (rangeValues === null) return value;
    return rangeValues.findIndex(item => value <= item);
};

const formatIndexRange = (rangeValues) => {
    return rangeValues?.map((item, index) => {
        if (index === 0) return `<${item}`;
        if (item === Infinity) return `>${rangeValues[index - 1]}`;
        return `${rangeValues[index - 1] + 1}-${item}`;
    }) ?? rangeValues;
};

module.exports = {
    getAQILegend: getAQILegend,
    indexColors: indexColors,
    airQualityIndexColors:airQualityIndexColors,
    CATEGORICAL_INDEXES: CATEGORICAL_INDEXES,
    getIndexRange: getIndexRange,
    formatIndexRange: formatIndexRange,
    getValueColorPosition: getValueColorPosition
};
